import BaseReducer from "shared/types/baseReducer";
import {
  Action,
  ActionType,
  CouponCodeFormValueType,
  DispatchInterface,
  State,
  UpdateStepAndParticipantDataArgType
} from "./type";
import { ApiRegistrationParticipantForParticipantResponse } from "../../../../shared/types/ApiRegistrationParticipantForParticipantResponse";

export default class Reducer extends BaseReducer<ActionType> implements DispatchInterface {
  static getInitialState(): State {
    return {
      stepNo: undefined,
      couponCodeFlowApplicable: false,
      couponCodeFormValues: undefined,
      participantData: undefined
    };
  }

  static reducer(state: State, action: ActionType): State {
    switch (action.type) {
      case Action.UPDATE_STEP:
        return { ...state, stepNo: action.payload };
      case Action.UPDATE_COUPON_CODE_FORM_VALUES:
        return { ...state, couponCodeFormValues: action.payload };
      case Action.UPDATE_COUPON_CODE_APPLICABLE_FLOW:
        return { ...state, couponCodeFlowApplicable: action.payload };
      case Action.UPDATE_PARTICIPANT_DATA:
        return { ...state, participantData: action.payload };
      case Action.UPDATE_STEP_AND_PARTICIPANT_DATA:
        return {
          ...state,
          stepNo: action.payload.stepNo,
          participantData: action.payload.participantData
        };
      default:
        return state;
    }
  }

  public updateStep(payload: number): void {
    return this.dispatch({ type: Action.UPDATE_STEP, payload });
  }

  public updateCouponCodeFormValues(payload: CouponCodeFormValueType) {
    return this.dispatch({ type: Action.UPDATE_COUPON_CODE_FORM_VALUES, payload: payload });
  }

  public updateParticipantData(payload: ApiRegistrationParticipantForParticipantResponse) {
    return this.dispatch({ type: Action.UPDATE_PARTICIPANT_DATA, payload });
  }

  public updateStepAndParticipantData(payload: UpdateStepAndParticipantDataArgType) {
    return this.dispatch({ type: Action.UPDATE_STEP_AND_PARTICIPANT_DATA, payload });
  }

  public updateCouponCodeApplicableFlow(payload: boolean) {
    return this.dispatch({ type: Action.UPDATE_COUPON_CODE_APPLICABLE_FLOW, payload });
  }
}
